export default __webpack_public_path__ + "static/media/Xd.ff913d9b.svg";